export default __webpack_public_path__ + "static/media/threeicon1.ee54e63b.png";